import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { AdminGuard } from './guard/admin.guard';
import { ExplorerGuard } from './guard/explorer.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      // {
      //   path: 'signup',
      //   component: SignupComponent,
      // },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'dpnf',
        loadChildren: () =>
          import('./dpnf/dpnf.module').then((m) => m.DpnfModule),
        canActivate: [AuthGuard, ExplorerGuard]
      },
      {
        path: 'query',
        loadChildren: () =>
          import('./query-search/query-search.module').then(
            (m) => m.QuerySearchModule
          ),
        canActivate: [AuthGuard]
      },
      { path: '**', redirectTo: '/login' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
